import Logout from './logout.tsx';

export default Logout;